export const environment = {
  production: window['env']['production'] || false,
  backendURL: window['env']['backendURL'] || 'http://localhost:8080/api',
  weatherConditionURL: window['env']['weatherConditionURL'] || 'https://api.openweathermap.org/data/2.5',
  endpointPQRS: window['env']['endpointPQRS'] || 'http://localhost:8080/radicacionpqr',
  endpointFacturacionElectronica: window['env']['endpointFacturacionElectronica'] || 'http://localhost:8080/api'
};
